// extracted by mini-css-extract-plugin
module.exports = {"settings":"settings_settings__m85JK","form":"settings_form__3yoHk","title":"settings_title__1-rkq","label":"settings_label__1e61e"};